<template>
  <el-form-item>
    <el-button type="primary" @click="deleteForm" plain v-if="isShowDel"
      >删除</el-button
    >
    <el-button
      type="primary"
      @click="submitForm(1)"
      v-if="isShowSave && isShowSaveBtn"
      >保存</el-button
    >
    <el-button type="primary" @click="submitForm(2)" v-if="isShowExamine"
      >提交审核</el-button
    >
  </el-form-item>
</template>

<script>
import { mapActions } from "vuex";
// import { windowHref } from "@/utils";
import { getStorage } from "@/utils/storage";
export default {
  name: "FormBtn",
  data() {
    return {
      companyId: "",
      farmId: "",
      isShowDel: false,
      isShowSave: false,
      isShowExamine: false,
    };
  },
  props: {
    isShowSaveBtn: {
      type: Boolean,
      default: true,
    },
  },
  async mounted() {
    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (getStorage("FARMINFO")) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
    await this.fnHasPermission();
  },
  methods: {
    ...mapActions("permission", ["hasPermission"]),
    submitForm(type) {
      if (type === 1) {
        this.$emit("submitForm", type);
      } else {
        const h = this.$createElement;
        this.$confirm("", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          customClass: "confirm-dialog",
          message: h("div", [
            h(
              "p",
              {
                style:
                  "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
              },
              `确定审核通过吗？`
            ),
            h(
              "p",
              {
                style:
                  "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
              },
              [
                h("span", null, "审核后的数据可通过"),
                h(
                  "i",
                  {
                    style: "color: #21C074;cursor:pointer",
                    on: {
                      click: () => {
                        console.log("lllllll");
                        // 回到农事记录页
                        this.goArigicRecordPage();
                      },
                    },
                  },
                  `【农事记录】`
                ),
                h("span", null, "中查看。"),
              ]
            ),
          ]),
          type: "warning",
        })
          .then(async () => {
            this.$emit("submitForm", type);
          })
          .catch(() => {});
      }
    },
    deleteForm() {
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `是否确定删除此条数据？`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [h("span", null, "删除后的数据将无法恢复。")]
          ),
        ]),
        type: "warning",
      })
        .then(async () => {
          this.$emit("deleteForm");
        })
        .catch(() => {});
    },
    goArigicRecordPage() {
      // windowHref("/home/batch", {
      //   companyId: this.companyId,
      //   farmId: this.farmId,
      //   tab: 1,
      //   periodType: 2,
      //   source: "hangyu",
      // });
      window.open(
        window.location.origin +
          `/index.html#/home/batch/company=${this.companyId}&farm=${this.farmId}&tab=1&periodType=2&source=hangyu`
      );
    },
    async fnHasPermission() {
      //删除
      this.isShowDel = await this.hasPermission(
        "produce:navigateCultivate:del"
      );
      //保存
      this.isShowSave = await this.hasPermission(
        "produce:navigateCultivate:save"
      );
      //提交审核
      this.isShowExamine = await this.hasPermission(
        "produce:navigateCultivate:examine"
      );
    },
  },
};
</script>
<style scoped lang="scss"></style>
